import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M5.417 5a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0Zm0 5a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0Zm0 5a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> <path d="M8.125 5h7.083m-7.083 5h7.083m-7.083 5h7.083" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);